import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { recognizeItems } from '../data/content';
import { Brand } from './Brand';
export function Recognize() {
  return <section className="w-full bg-slate-900 px-8 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-259" data-mp="30zki244294n9">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-260" data-mp="2w4eul0v0fhx2">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-5" data-id="element-261" data-mp="2r6lnm5lvujvq">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-262" data-mp="2m8k81uno12p0">
            你有沒有試過這樣？
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-263" data-mp="2i55h48y6v1ws">
            只要有一項答「有」，<Brand data-id="element-264" data-mp="2d8f1tnu7kacf" /> 就是為你而設。
          </p>
          <a href="#inside" className="group mt-10 inline-flex items-center gap-2 font-serif text-2xl italic text-red-300 transition-colors duration-150 ease-out hover:text-stone-50" data-id="element-265" data-mp="288ivvj1ya8u8">
            你值得更輕鬆的方法
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-266" data-mp="6h61vp1itlcy" />
          </a>
        </div>

        <ul className="divide-y divide-white/10 border-y border-white/10 lg:col-span-7" data-id="element-267" data-mp="3jjsij938fdyt">
          {recognizeItems.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex gap-5 py-7 sm:gap-6" data-id="element-268" data-mp="39nxt9v4i6kn2">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/15 text-red-300" data-id="element-269" data-mp="3elh6qstdmtdy">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-270" data-mp="67ifg4hcnw6s" />
                </span>
                <div data-id="element-271" data-mp="b48s0hty49ng">
                  <h3 className="font-serif text-2xl leading-tight sm:text-3xl" data-id="element-272" data-mp="b4h5obxw7izp">{item.title}</h3>
                  <p className="mt-2 leading-relaxed text-stone-50/70" data-id="element-273" data-mp="3sl8pt7yr2zyt">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}